import { AbstractPmsApiService } from "./abstract.service";
import { GuestReservationHistory } from "../models";
/**
 * @class GuestReservationHistoryPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<GuestReservationHistory>}
 */
export class GuestReservationHistoryPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/guest/:guestId/reservation-history';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {GuestReservationHistory}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new GuestReservationHistory(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Guest=} guest
     * @returns {Promise.<PaginationCollection<GuestReservationHistory>>}
     */
    get(params = {}, guest) {
        
        const url = this.url({
            guestId: guest.id
        });
        
        const ignoreLB = params.hasOwnProperty('searchValue');
        
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/guest-reservation-history.service.js